import React, { useEffect, useState } from "react";
import axios from "axios";
// import { Link } from "react-router-dom";
import { FaTimes, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Brands1 from "../components/brands/Brands1";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const Csr = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabs, setTabs] = useState([{ key: "all", label: "All" }]);

  // ✅ Fetch CSR Gallery Images
  useEffect(() => {
  const fetchGalleryImages = async () => {
    try {
      // 1️⃣ Get gallery list first
      const galleryRes = await axios.get("https://www.isolsgroup.com/new/api/ApiGalleryCategory", {
        headers: { "X-API-KEY": "ISOLS" },
      });

      // 2️⃣ Find only CSR galleries
      const csrGalleries = galleryRes.data.data.filter(
        (g) => g.gallerycategory?.toLowerCase() === "csr"
      );

      // 3️⃣ Extract CSR gallery IDs
      const csrIds = csrGalleries.map((g) => String(g.id));

      // 4️⃣ Get all images
      const imageRes = await axios.get("https://www.isolsgroup.com/new/api/ApiGalleryImage", {
        headers: { "X-API-KEY": "ISOLS" },
      });

      // 5️⃣ Filter only CSR images
      const filteredImages = imageRes.data.data.filter((img) =>
        csrIds.includes(String(img.gallery_id))
      );

      // 6️⃣ Create unique tabs for CSR
      const uniqueTabs = [
        { key: "all", label: "All", gallery_id: "all" },
        ...csrGalleries.map((g, index) => ({
          key: `${g.id}-${index}`,
          label: g.gallery_thumb_name || `Gallery ${index + 1}`,
          gallery_id: String(g.id),
        })),
      ];
      setTabs(uniqueTabs);

      // 7️⃣ Format images for display
      const formatted = filteredImages.map((item) => ({
        id: item.id,
        src: item.image || item.image_url,
        gallery_id: String(item.gallery_id),
      }));

      setImages(formatted);
    } catch (error) {
      console.error("Error loading CSR Gallery:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchGalleryImages();
}, []);

  // ✅ Filter images by selected tab
  const filtered =
    activeTab === "all"
      ? images
      : images.filter((img) => img.gallery_id === activeTab);

  // ✅ Lightbox Navigation
  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) =>
      prev > 0 ? prev - 1 : filtered.length - 1
    );
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) =>
      prev < filtered.length - 1 ? prev + 1 : 0
    );
  };

  return (
    <div className="page-container">
      {/* 🔹 Breadcrumbs Header */}
        <BreadcrumbsHeader 
        title="CSR" 
        backgroundImage="/images/header/csr-cover.jpg" 
      />



      {/* 🔹 About Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className="b-mod-heading text-center">
                <p className="first-heading font-secondary">
                  Share and be the reason for someone's Smile
                </p>
                <h2 className="heading-line line-right customColor customPseudoElBg">
                  <strong>Corporate Social Responsibility</strong>
                </h2>
                <p className="second-heading font-additional">
                  It is the responsibility of the corporation operating within
                  society to contribute towards economic, social and
                  environmental development that creates positive impact on
                  society at large.
                  <br />
                  <br />
                  For us “Corporate” means who ‘Co-operate’ and we as a team
                  have always contributed towards social and environmental
                  issues for the wellbeing of this planet.
                  <br />
                  <br />
                  All CSR activities of ISOLS Group are done under a
                  non-profitable foundation called ‘SYMPHONY - Ek Abhiyaan’,
                  working for upliftment and nurturing of underprivileged youth.
                  <br />
                  <br />
                  We wholeheartedly welcome every individual who wants to be a
                  part of these social initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          {/* 🔹 Tabs */}
          {/* <ul className="gallery-tabs">
            {tabs.map((tab) => (
              <li
                key={tab.key}
                className={activeTab === tab.key ? "active" : ""}
                onClick={() => {
                  setActiveTab(tab.key);
                  setSelectedIndex(null);
                }}
              >
                {tab.label}
              </li>
            ))}
          </ul> */}
          <ul className="gallery-tabs">
            {tabs.map((tab) => (
              <li
                key={tab.key}
                className={activeTab === tab.key ? "active" : ""}
                onClick={() => {
                  setActiveTab(tab.gallery_id || "all"); // filter uses gallery_id
                  setSelectedIndex(null);
                }}
              >
                {tab.label}
              </li>
            ))}
          </ul>

          {/* 🔹 Image Grid */}
          {loading ? (
            <p className="text-center">Loading gallery...</p>
          ) : filtered.length > 0 ? (
            <div className="gallery-grid">
              {filtered.map((item, index) => (
                <div
                  key={index}
                  className="gallery-item"
                  onClick={() => setSelectedIndex(index)}
                >
                  <img
                    src={`https://www.isolsgroup.com/uploaded-images/gallery/${item.src}`}
                    alt={item.gallery_category_name || "CSR"}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center">No images found.</p>
          )}

          {/* 🔹 Lightbox */}
          {selectedIndex !== null && filtered[selectedIndex] && (
            <div className="lightbox" onClick={() => setSelectedIndex(null)}>
              <button className="close-btn">
                <FaTimes />
              </button>

              <button className="arrow left" onClick={handlePrev}>
                <FaArrowLeft />
              </button>

              <img
                src={`https://www.isolsgroup.com/uploaded-images/gallery/${filtered[selectedIndex].src}`}
                alt="Large View"
                className="lightbox-img"
              />

              <button className="arrow right" onClick={handleNext}>
                <FaArrowRight />
              </button>
            </div>
          )}
        </div>
      </section>

      {/* 🔹 Brands Section */}
      <Brands1 />
    </div>
  );
};

export default Csr;
